<div class="footer" theme>
  <dxc-footer
    logoSrc="{{
      RESOURCE_SERVER_URL + '/assets/images/footer/DXC_Logo_white.svg'
    }}"
    copyright="{{ 'footer.rights' | translate }}"
    [socialLinks]="footerSocialLinks"
    [bottomLinks]="footerBottomLinks"
    margin="medium"
  >
  </dxc-footer>
</div>
